import React from 'react';

const ThisConceptLabel = () => {
  return (
    <div className='col-xs-12 no-side-padding'>
      <span className='resource-label'>
        <span className='this-concept small'>
          THIS CONCEPT
        </span>
      </span>
    </div>
  )
}

export default ThisConceptLabel;
